export const ROLE_FAN = 'fan';
export const ROLE_CELEBRITY = 'celebrity';
